import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-gradient-progressbar",
  templateUrl: "./gradient-progressbar.component.html",
  styleUrl: "./gradient-progressbar.component.scss",
})
export class GradientProgressbarComponent implements OnChanges {
  @Input() progress: number = 50; // 0 to 100

  private colorStops = [
    { stop: 0, color: "#554440" },
    { stop: 19.65, color: "#D14447" },
    { stop: 41.8, color: "#E0842F" },
    { stop: 69.5, color: "#FFCC5F" },
    { stop: 100, color: "#6EBC14" },
  ];

  markerColor: string = this.colorStops[0].color;

  ngOnChanges(changes: SimpleChanges) {
    if (changes["progress"]) {
      this.markerColor = this.getColor(this.progress);
    }
  }

  getColor(percent: number): string {
    for (let i = 0; i < this.colorStops.length - 1; i++) {
      const current = this.colorStops[i];
      const next = this.colorStops[i + 1];
      if (percent >= current.stop && percent <= next.stop) {
        const factor = (percent - current.stop) / (next.stop - current.stop);
        return this.interpolateColor(current.color, next.color, factor);
      }
    }
    return this.colorStops[this.colorStops.length - 1].color;
  }

  private interpolateColor(start: string, end: string, factor: number): string {
    const hexToRgb = (hex: string) =>
      hex
        .replace("#", "")
        .match(/.{1,2}/g)!
        .map((x) => parseInt(x, 16));
    const rgbToHex = (rgb: number[]) =>
      "#" + rgb.map((x) => x.toString(16).padStart(2, "0")).join("");
    const startRGB = hexToRgb(start);
    const endRGB = hexToRgb(end);
    const result = startRGB.map((s, i) =>
      Math.round(s + factor * (endRGB[i] - s)),
    );
    return rgbToHex(result);
  }
}
